import React from 'react';
import { AvatarThread } from '../avatar-thread';
import { TextSkeleton } from '../text-skeleton';
import { AvatarContainer, Column, SkeletonWrapper } from './styled';
export var NotificationItemSkeleton = function NotificationItemSkeleton(_ref) {
  var positionInGroup = _ref.positionInGroup,
    className = _ref.className;
  return /*#__PURE__*/React.createElement(SkeletonWrapper, {
    "data-testid": "notification-item-skeleton",
    "aria-hidden": true
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ,
    className: className
  }, positionInGroup ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(AvatarThread, {
    positionInGroup: positionInGroup
  }, /*#__PURE__*/React.createElement(AvatarContainer, null))) : /*#__PURE__*/React.createElement(AvatarContainer, null), /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(TextSkeleton, {
    height: "16px"
  }), /*#__PURE__*/React.createElement(TextSkeleton, {
    width: "344px",
    marginBottom: "6px"
  }), /*#__PURE__*/React.createElement(TextSkeleton, {
    width: "100px",
    height: "12px"
  })));
};